define('gigaset_recurring/classes/provider/billwerk/steps/cart',[
	"jquery",
	"lodash",
	"./_abstract",
	"cartware/jquery/bem",
	"cartware/components/Logger",
	"cartware/components/Config",
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Logger,
	Config
) {

	function CartStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring.cart");
	}

	CartStep.prototype = _.create(new AbstractStep, {
		constructor: CartStep,

		_shouldDisplaySidebar: false,
		_displayInSidebar: false,

		initialize: function() {
			this.cartBlock				= BEM.block("gigaset-recurring-cart");
			this.cartPreviewSlot		= this.cartBlock.getElements("preview-slot");
			this.cartPreviewTmpl		= _.template(this.cartBlock.getElements("tmpl-preview").html());
			this.cartTotalsTmpl			= _.template(this.cartBlock.getElements("tmpl-cart-totals").html());
			this.cartRowTmpl			= _.template(this.cartBlock.getElements("tmpl-cart-row").html());
			this.cartIntervalTmpl		= _.template(this.cartBlock.getElements("tmpl-cart-item-interval").html());
			this.nextBillingTmpl		= _.template(this.cartBlock.getElements("tmpl-next-billing").html());
			this.trialPeriodTmpl		= _.template(this.cartBlock.getElements("tmpl-trial-period").html());
			this.contractPeriodTmpl		= _.template(this.cartBlock.getElements("tmpl-contract-period").html());
			this.periodTmpl				= _.template(this.cartBlock.getElements("tmpl-period").html());

			this.cartItemImage			= this.cartBlock.getElements("tmpl-cart-item-image").html();
			this.cartItemDescription	= _.template(this.cartBlock.getElements("tmpl-cart-item-info").html());


			this.renderPreview();
			this.bindEvents();

			window.discountForm = {
				submit: _.bind(this.submitDiscountForm, this)
			};
		},

		collectFormData: function() {
			return {
				cart: this.getData("cart"),
				customer: _.merge({}, this.getData("customer"))
			};
		},

		bindEvents: function() {
			this.cartPreviewSlot
				.on("submit", "#discount-coupon-form-node", _.bind(function(e) {
					e.preventDefault();
					this.submitDiscountForm(false, $(e.target).find("button"));
				}, this))
				.on("click", ".btn-proceed-checkout", _.bind(this.submit, this));

			this.getData("module").on("preview.reloaded", _.bind(this.renderPreview, this));
			this.getData("module").on("updateBlocks", _.bind(this.updateBlocks, this));
		},

		updateBlocks: function(blocks) {
			var render = false;

			if ("preview_totals" in blocks) {
				this.cartTotalsTmpl =  _.template(blocks["preview_totals"]);
				render = true;
			}

			render && this.renderPreview();
		},

		renderPreview: function() {
			this.logger.info("render preview");

			var self = this,
				data = this.getData("preview"),
				priceFormat = this.getData("priceFormat");

			var setupFee = parseFloat(_.get(data, 'Order.SetupFee.TotalNet', 0.00)) + parseFloat(_.get(data, 'Order.SetupFee.TotalVat', 0.00));
			var recurringFee = parseFloat(_.get(data, "Order.RecurringFee.LineItems[0].TotalGross", 0.00));
			var subtotal = parseFloat(data.Order.TotalGross);

			var feePeriod = data.Order.RecurringFee.FeePeriod;
			var trialPeriod = _.get(data, 'Order.TrialPeriod');

			var shippingCosts =  _.reduce(
				_.filter(
					_.get(data, 'Order.RatedItems', []),
					function(item) {
						return /^SHIPPING\|/.match(_.get(item, 'Description', ''));
					}
				),
				function(result, item) {
					return result + _.get(item, 'TotalGross');
				},
				0
			);

			var contractPeriod = _.get(this.getData("plan"), 'ContractPeriod');

			var endAfterFirstContractPeriod = _.get(this.getData("plan"), 'EndAfterFirstContractPeriod');

			if (contractPeriod) {
				contractPeriod.endAfterFirstContractPeriod = endAfterFirstContractPeriod;
			}

			// var nextBillingDate = this.dateFormatter.parseDate(_.get(data, 'Order.NextTotalGrossDate'), 'Y-M-y H:i:s');

			var nextBillingDateFormatted = Config.get('recurring.provider.billwerk.order.preview.next_total_gross_date_formatted');

			this.cartPreviewSlot.html(
				this.cartPreviewTmpl({
					plan: this.getData("plan"),
					cartItemImage: this.cartItemImage,
					cartItemDescription: this.cartItemDescription({
						recurringInterval: endAfterFirstContractPeriod
							? ''
							: this.cartIntervalTmpl(feePeriod),
						trialPeriod: trialPeriod ? ('<br/>' + this.trialPeriodTmpl(trialPeriod)) : '',
						contractPeriod: contractPeriod ? (this.contractPeriodTmpl(contractPeriod) + '<br/>') : '',
						nextBillingDate: endAfterFirstContractPeriod
							? ''
							: ('<br />' + this.nextBillingTmpl({date: Config.get('recurring.provider.billwerk.order.preview.next_total_gross_date_formatted')}))
					}),
					nextBillingDateFormatted: nextBillingDateFormatted,
					Order: data.Order,
					shippingCosts: shippingCosts,
					totals: this.getData("totals"),
					description_after: '',
					recurringFee: recurringFee,
					price: formatCurrency(recurringFee, priceFormat),
					qty: _.get(data, 'Order.RecurringFee.Quantity'),
					setupFee: formatCurrency(setupFee, priceFormat),
					subtotal: formatCurrency(subtotal, priceFormat),
					priceFormat: priceFormat,
					renderTotals: this.cartTotalsTmpl,
					renderRow: this.cartRowTmpl,
					// subtotals: "<tr><td colspan='2'>TEST</td></tr>",
					subtotals: "",
					showCouponBox: this.getData('quote.coupon.show'),
					renderInterval: function(period) {
						return self.cartIntervalTmpl(period);
					},
					renderPrice: function(price) {
						return formatCurrency(price, priceFormat);
					},
					renderPeriod: function(period) {
						return self.periodTmpl(period);
					}
				})
			);

			this.emit("layout");
		},

		submitDiscountForm: function(clear, button) {
			var cart = this.getData("cart");

			clear = !!clear;
			button = $(button);

			var couponCode = $("#coupon_code").val();
			if ("" === _.trim(couponCode)) return;

			if (clear) {
				if ("couponCode" in cart) {
					delete cart.couponCode;
				}
			} else {
				cart.couponCode = couponCode;
			}

			button.button("loading");

			// this.renderPreview();
			this.emit("requestPreview");
		}
	});

	return CartStep;

});
